var ApplicantAPI = require("../../../common/api/applicant");
module.exports = function ($scope) {
  var vm = this;
  $scope.submit = function () {
    $scope.closeThisDialog({action:"close"});
  };
  $scope.cancel = function () {
    $scope.closeThisDialog({action:"cancel"});
  };

  vm.applicantOrganisationName = '';
  vm.selectedObject = {};
  vm.hasExisting = false;
  vm.contactName = '';
  vm.email = '';
  vm.position = '';
  vm.contactNumber = '';

  vm.basicApplicantDetails = {};
  
  $scope.GetApplicants = function(str){
    
    vm.applicantOrganisationName = str;
    return ApplicantAPI.GetApplicantsForTypeahead(vm.applicantOrganisationName);
    //.then(function(results){      $scope.filteredApplicants = results;    })
  }

  $scope.confirm = function() {
    //set some values
    $scope.closeThisDialog({action:"confirm", applicant : {
      applicantId: vm.applicantId,
      contactName: vm.contactName,
      contactNumber: vm.contactNumber,
      email: vm.email,
      position: vm.position
    }});
  }

  $scope.selectExisting = function (selected) {
    vm.selectedObject = selected;
    vm.hasExisting = true;
    vm.applicantId = vm.selectedObject.originalObject.applicantId;
    ApplicantAPI.GetApplicantById(vm.applicantId, 'ApplicantBasicDetailsView').then(function(result){
      vm.basicApplicantDetails = result;
    })
  };
};
